import { style } from 'typestyle/lib';

export const MACRO_SUMMARIES_HEIGHT = 149;

export const dataContainerStyle = style({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
});

export const macroGridStyle = style({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  $nest: {
    '.header-row': {
      fontWeight: 700,
    },
    '.macro-container': {
      flex: '1',
      $nest: {
        '& .macro-summaries': {
          display: 'flex',
          flexWrap: 'wrap',
          width: '100%',
        },
      },
    },
    '.grid-container': {
      flex: '1',
      $nest: {
        '& .data-grid': {
          height: '100%',
        },
      },
    },
  },
});

export const containerPrintMode = style({
  display: 'flex',
  flexDirection: 'column',
  $debugName: 'container-printmode',
  $nest: {
    '.data-container': {
      display: 'flex',
      flexDirection: 'column',
      height: 'initial',
      flex: '1 0',
      $nest: {
        '.macro-summaries': {
          height: 'initial',
        },
        '.grid-container': {
          display: 'flex',
          flex: '1 0 ',
          height: 'initial',
          $nest: {
            '.data-grid': {
              flex: '1 0',
              height: 'initial',
            },
          },
        },
      },
    },
  },
});
